import { Dispatch } from "redux"

export type ToastActionType = {
  type?: string
  data?: object
}

export type ToastStateType = {
  message: toast | object
  show: boolean
}

type toast = {
  headerMessage?: string
  bodyMessage: string
}

/************************************
 * ACTION TYPE
 ************************************/
export const REDUX_SET_TOAST_DATA = "REDUX_SET_TOAST_DATA"
export const REDUX_ERASE_TOAST = "REDUX_ERASE_TOAST"

/************************************
 * ACTIONS
 ************************************/
export const setToastData: (data: toast) => any = data => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: REDUX_SET_TOAST_DATA,
      data: data,
    })
  }
}

export const eraseToast = () => {
  return {
    type: REDUX_ERASE_TOAST,
  }
}

/************************************
 * REDUCER
 ************************************/
const initialState: ToastStateType = {
  message: {},
  show: false,
}

export default (
  state: ToastStateType = initialState,
  action: ToastActionType
) => {
  switch (action.type) {
    case REDUX_SET_TOAST_DATA:
      return {
        message: action.data,
        show: true,
      }
    case REDUX_ERASE_TOAST:
      return {
        message: {},
        show: false,
      }
    default:
      return state
  }
}
